/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const NextActionResponse = zod.object({
  at: zod
    .string()
    .optional()
    .describe('Offset-bearing ISO-8601 start time; present for appointments only'),
  contentUuid: zod
    .uuid()
    .describe(
      'appointment: the Path Workflow root; task: the task content; approval: the pending share or group invite',
    ),
  kind: zod.enum(['appointment', 'task', 'approval']).describe('Which source the item came from'),
  reason: zod.string().describe('Why this item is next, ready to display'),
  subtitle: zod.string(),
  title: zod.string(),
});

export type NextActionResponse = zod.input<typeof NextActionResponse>;
export type NextActionResponseOutput = zod.output<typeof NextActionResponse>;
